import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/Kidola.css'; // Adjust the path as necessary

import { useNavigate } from 'react-router-dom';

const BookRequestDetailPage = ({ isSidebarCollapsed }) => {
    const { bookRequestId } = useParams();
    const [bookRequest, setBookRequest] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBookRequestDetails = async () => {
            try {
                const response = await api.post('/inventory/getBookRequest', {
                    data: {
                        bookRequestId: bookRequestId
                    }
                });
                const bookRequestData = response.data.data || null;
                setBookRequest(bookRequestData);
            } catch (error) {
                console.error("Failed to fetch book request details", error);
            }
        };

        fetchBookRequestDetails();
        
        
        
        
    }, [bookRequestId]);
   
    const handleSubmit = (status) => {
        
        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }

        const requestBody = {
            data: {
                bookRequestData: {
                    bookRequestId: bookRequestId,
                    status_name: status  
                }
            }
        };

        api.post(`inventory/bookRequestUpdate`, requestBody)
        .then(response => {
            console.log('Book Request submitted successfully:', response.data);
            const successMessage = response.data.message;
            console.log(successMessage);
            navigate('/success', { state: { message: successMessage } });
            
        })
        .catch(error => {
            console.error('Error adding student:', error);
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        });
    };

    if (!bookRequest) return <p>Loading Book Request details...</p>;

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''} spp-payment`}>
            <div className="page-title">Book Request Detail</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Request Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Teacher Name</td>
                                <td>:</td>
                                <td>{bookRequest.Teacher.teacher_name}</td>
                            </tr>
                            <tr>
                                <td>Branch</td>
                                <td>:</td>
                                <td>{bookRequest.Branch ? bookRequest.Branch.branch_name : "Central"}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>:</td>
                                <td>{bookRequest.Status.status_name}</td>
                            </tr>
                            <tr>
                                <td>Requested On</td>
                                <td>:</td>
                                <td>{moment(bookRequest.requested_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            {bookRequest.approved_on!=null ?
                            <tr>
                                <td>Approved On</td>
                                <td>:</td>
                                <td>{moment(bookRequest.approved_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            :""}
                            {bookRequest.rejected_on!=null ?
                            <tr>
                                <td>Rejected On</td>
                                <td>:</td>
                                <td>{moment(bookRequest.rejected_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            :""}
                        </tbody>
                    </table>
                </div>
                {bookRequest.BookRequestDetails.length>0 &&
                <div className="create-student-table">
                    <h3 className="section-header">Book Request Details</h3>
                    <table>
                        <thead>
                        <tr>
                        <th className='table-center-align'>No</th>
                            <th className='table-center-align'>Requested Item</th>
                            <th className='table-center-align'>Item Type</th>
                            <th className='table-center-align'>Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        {bookRequest.BookRequestDetails.map((detail, index) => (
                            <tr key={detail.book_request_detail_id}>
                                <td class="no-column">{index + 1}</td>
                                <td>{detail.Inventory.item_name}</td>
                                <td>{detail.Inventory.item_type}</td>
                                <td>{detail.amount}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                }
                {bookRequest.Status.status_name === "WAITING APPROVAL"?
                <div className="approve-reject-container">
                    <button className="approve-reject-button" onClick={() => handleSubmit('APPROVED')}>Approve</button>  
                    <button className="profile-button" onClick={() => handleSubmit('REJECTED')}>Reject</button>
                </div>
                :""}
                <div className="search-container">  
                    <button onClick={() => navigate(`/`)}>Back</button>
                </div>
            </div>
        </div>
    );
};

export default BookRequestDetailPage;
